import { ACLEntityTypeFieldDto } from './aclEntityTypeField.dto';
import { BaseDto } from './base.dto';

export class ACLEntityTypeDto extends BaseDto{  
    dbName: string;
    fullName: string;
    description: string;
    defaultData: string;
    fields?: ACLEntityTypeFieldDto[];
}